export type LinkedProductCategoryMessages = {
  saveButton: string;
  deleteButton: string;
  deleteDialogTitle: string;
  deleteDialogMessage: string;
  confirmButton: string;
  cancelButton: string;
  deleteSuccess: string;
  deleteError: string;
  saveSuccess: string;
  saveError: string;
  errorNoCategoriesSelected: string;
  errorNoProductId: string;
};

export const LINKED_PRODUCT_CATEGORY_MESSAGES: LinkedProductCategoryMessages = {
  saveButton: "Salvar Categorias",
  deleteButton: "Remover Todas",
  deleteDialogTitle: "Confirmar Remoção",
  deleteDialogMessage:
    "Todas as categorias vinculadas serão removidas. Esta ação é irreversível. Deseja continuar?",
  confirmButton: "Sim, Remover",
  cancelButton: "Cancelar",
  deleteSuccess: "Categorias removidas com sucesso!",
  deleteError: "Erro ao remover categorias",
  saveSuccess: "Categorias salvas com sucesso!",
  saveError: "Erro ao salvar categorias",
  errorNoCategoriesSelected: "Selecione pelo menos uma categoria",
  errorNoProductId: "Produto não identificado. Salve o produto primeiro.",
};
